var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip.top",value:({
    content: _vm.tooltipText,
    delay: { show: 500, hide: 0 },
    hideOnClick: true,
  }),expression:"{\n    content: tooltipText,\n    delay: { show: 500, hide: 0 },\n    hideOnClick: true,\n  }",modifiers:{"top":true}}],staticClass:"leading-none"},[_vm._v("\n  "+_vm._s(_vm.timeAgoValue)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }